export enum enumCustomEventLogName {
  GA_PURCHASE_PUSH = 'ga_purchase_push',
  GA_PURCHASE_PUSH_STARTED = 'ga_purchase_push_started',
  GA_PURCHASE_PUSH_PROCESSING = 'ga_purchase_push_processing',
  GA_PURCHASE_PUSH_ENDED = 'ga_purchase_push_ended',
  PURCHASE_STARTED = 'purchase_started',
  PURCHASE_DEADEND = 'purchase_deadend',
  PURCHASE_ERROR = 'purchase_error',
  PAYMENT_SERVICE_ERROR = 'payment_service_error',
  PAYMENT_RESULT_ERROR = 'payment_result_error',
  PAYMENT_RESULT_START = 'payment_result_start',
}
